import { http } from "@/core/api/";

const apiUrl = "api/virtualassistant";

export const sendChat = payload => {
  return http.post(`${apiUrl}/chat`, payload, {
    headers: {
      skipLoading: true
    }
  });
};

export const getCitationFile = async citation => {
  return http.get(`${apiUrl}/citation/file`, {
    params: {
      citation
    },
    headers: {
      skipLoading: true
    }
  });
};
